<template>
  <div id="app">
    <Header />
    <div class='main-container'>
      <SideBar />
      <main>
        <div class='content-wrapper'>
          <div class='content'>
            <router-view />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import SideBar from './components/SideBar.vue'
export default {
  name: 'app',
  components: {
    Header,
    SideBar
  }
}
</script>


<style lang="less">
* {
  box-sizing: border-box;
}

html, body {
  background-color: #e2e1e0;
  color: #333;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  padding: 0;
  margin: 0;
  text-rendering: optimizeLegibility;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
}

#app {
  height: 100%;
  min-height: 100%;
}

img {
  vertical-align: middle;
}

.main-container {
  display: flex;
  flex-grow: 1;
  height: 100%;
  max-height: 100%;
}

a {
  text-decoration: none;
  text-shadow: 0 0 0px #3690ff;
  color: #3690ff;
  font-weight: 400;
}

main {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.5);
  border-top: 3px solid #488AC7;
  max-height: calc(100vh - 64px);
}

.content-wrapper {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
}

.content {
  display: inline-block;
  min-width: 50%;
  padding: 25px;
  border-radius: 3px;
  margin: 32px;
  position: relative;
  align-items: center;
  flex-grow: 1;
  background: #F1F1F1;
  max-height: calc(100vh - 131px);
}

// @media(max-width: 768px) {
  main {
    max-width: calc(100% - 64px);
  }
// }

footer {
  text-align: center;
  margin: 30px 0px;
  color: #FFF;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.4);
  background: rgba(0, 0, 0, 0.1);
  padding: 32px;

  .btn, .btn-soft {
    background: rgba(255,255,255,0.6);
    box-shadow: 0px 0px 3px rgba(0,0,0,0.2);

    &:hover {
      background: rgba(255, 255, 255, 1);
    }
  }
}

.loading > * {
  filter: blur(2px);
}

.loading {
  position: relative;
}

.loading::before, .error::before {
  position: absolute;
  z-index: 2;
  background: rgba(255, 255, 255, 0.3);
  text-shadow: 0 0 2px white;
  padding: 16px;
}

.content:empty {
  position: relative;
}

.loading:not(.error)::before { content: 'Loading...'; }
.content:empty::after, .loading:not(.error)::after {
  background: url(https://maplestory.io/api/gms/32/mob/1210102/render/move) no-repeat center;
}

.error::before { content: 'Sorry, something went wrong. Try again later.'; }
.error::after {
  background: url(https://maplestory.io/api/gms/32/mob/1210102/render/hit1) no-repeat center;
}

.hover a {
  box-shadow: 0 0 2px black;
  background: white;
}
</style>
